import './YearStrip.css';

export interface YearGroup {
    year: number;
    count: number;
    avgAttendance: number;
    delta: number | null;
}

type Props = {
    years: YearGroup[];
    selectedYear?: number;
    onSelect: (year: number | undefined) => void;
    formatAttendance: (value: number) => string;
    meetingsLabel: string;
    ariaLabel: string;
    pillTitle: (year: number) => string;
};

const YearStrip = ({ years, selectedYear, onSelect, formatAttendance, meetingsLabel, ariaLabel, pillTitle }: Props) => (
    <div className='year-strip' role='group' aria-label={ariaLabel}>
        {years.map((group) => {
            const isActive = selectedYear === group.year;
            return (
                <button
                    key={group.year}
                    type='button'
                    className={`year-pill${isActive ? ' is-active' : ''}`}
                    onClick={() => onSelect(isActive ? undefined : group.year)}
                    title={pillTitle(group.year)}
                >
                    <span className='year-pill-top'>
                        <span className='year-pill-year'>{group.year}</span>
                        <span className='year-pill-attendance'>
                            · {formatAttendance(group.avgAttendance)}
                            {group.delta !== null && group.delta !== 0 && (
                                <span className={`year-pill-delta ${group.delta > 0 ? 'up' : 'down'}`}>
                                    {group.delta > 0 ? '▲' : '▼'}
                                    {Math.abs(group.delta)}
                                </span>
                            )}
                        </span>
                    </span>
                    <span className='year-pill-meta'>
                        {group.count} {meetingsLabel}
                    </span>
                </button>
            );
        })}
    </div>
);

export default YearStrip;
